// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'steptemplates'

/**
 * StepTemplates Model Interface (auto-generated from Drizzle schema)
 */
export interface StepTemplatesModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description?: string
  category: string
  stepType: string
  action: Record<string, unknown>
  inputs?: Record<string, unknown>
  outputs?: Record<string, unknown>
  outputExtraction?: Record<string, unknown>
  requiredVariables?: string[]
  cli?: Record<string, unknown>
  versionField?: string
  tags?: string[]
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "category": {
          "type": "string",
          "maxLength": 200
      },
      "stepType": {
          "type": "string",
          "maxLength": 200
      },
      "action": {
          "type": "object"
      },
      "inputs": {
          "type": "object"
      },
      "outputs": {
          "type": "object"
      },
      "outputExtraction": {
          "type": "object"
      },
      "requiredVariables": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "cli": {
          "type": "object"
      },
      "versionField": {
          "type": "string",
          "maxLength": 200
      },
      "tags": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "category",
      "stepType",
      "action",
      "archived",
      "workspaceId"
  ],
  indexes: [
      [
          "orgId",
          "workspaceId",
          "category",
          "title"
      ],
      [
          "orgId",
          "name"
      ],
      [
          "category",
          "stepType"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
